declare const require: any;

// TSC cannot find this type from the auth0 package, so is redefined here.
type CacheLocation = 'localstorage' | 'memory';

export const environment = {
  name: 'production',
  version: require('../../package.json').version,
  title: 'MyRobot.cloud | Palletizing Robot Management System | Rocketfarm',
  development: false, // Watermark GUI
  production: true, // Angular build prod
  auth0: {
    domain: 'login.myrobot.cloud',
    clientId: 'vZrLXxEhzyyP3kfK6S7y5RxOTrAvsLdY',
    useRefreshTokens: true,
    response_type: 'token id_token',
    scope: 'openid profile email',
    cacheLocation: 'localstorage' as CacheLocation,
    authorizationParams: {
      audience: 'https://palletizer-v2.rocketfarm.no',
      redirect_uri: `${window.location.origin}/user/callback`,
    },
  },
  boo: '42b56fb1-2e4e-4459-b09e-6a451d491eb3',
  googleAnalyticsGtag: 'UA-119030843-1',
  grapqlURL: 'https://hasura.myrobot.cloud/v1/graphql',
  grapqlWebSocketURL: 'wss://hasura.myrobot.cloud/v1/graphql',
  pdfReportURL:
    'https://palletbuilderapi.azurewebsites.net/api/PdfGenerator?code=2D_OASsH31rrb9n_DT1bfi8E4ZSlulrlYQBMCjUdJ0PYAzFuubBmew==',
  pdfReportParams: '/output?name=PPB_report&format=pdf&output=base64',
  pdfReportTemplate: '209021',
  learnMoreFallbackUrl:
    'https://rocketfarm.atlassian.net/wiki/spaces/MKB/overview',
  reCaptchaSiteKey: '6LemDfAqAAAAAH5hdcXLYt8JZTyOAx4tYMonH2Ji',
  quoteReqestActionKey: 'SimulationQuoteRequest',
  backofficeOrgs: [
    '42b56fb1-2e4e-4459-b09e-6a451d491eb3',
    '9d472f62-919b-495d-9cad-56dcb1640a7c',
    'd15d1c31-24bd-4024-a647-8bffc4da2d12',
  ],
  atlassianServiceWidgetKey: '8c010cae-8a23-4e75-8e0a-480d26fa800b',
  contentfulLandingPageId: '9z2yBwMtxcnDMJvKQg9oq',
};
